'use client';

import { useEffect } from 'react';
import { useLocale } from 'next-intl';
import { useCurrentUser } from '../hooks/useCurrentUser';

interface SigninModalProps {
  isOpen: boolean;
  onClose: () => void;
  callbackUrl?: string;
}

/**
 * Login is owned by the central accounts app. This "modal" no longer renders
 * in-portal provider UI — opening it bounces to the portal /auth/signin route,
 * which server-redirects to `${ACCOUNTS_URL}/login?app=portal&return=…&lang=…`.
 * Kept as a component so the many trigger surfaces (header, landing, CTA, about,
 * AuthStatus) keep working unchanged.
 */
export default function SigninModal({ isOpen, callbackUrl }: SigninModalProps) {
  const locale = useLocale();
  const { isAuthenticated } = useCurrentUser();

  useEffect(() => {
    if (!isOpen || isAuthenticated) return;
    const cb =
      callbackUrl ??
      (typeof window !== 'undefined'
        ? window.location.pathname + window.location.search
        : '/');
    window.location.href = `/${locale}/auth/signin?callbackUrl=${encodeURIComponent(cb)}`;
  }, [isOpen, isAuthenticated, callbackUrl, locale]);

  return null;
}
